import apiHandling from "./apiHandling";

class apiDemoCourseSets extends apiHandling {
    static getDemoCourSet = () => this.req({
            method: 'get',
            action: 'demoCourseSets/getDemoSet'
        });

}

export default apiDemoCourseSets;